import { useTranslation } from "react-i18next";

const brands = [
  { name: "Roto", abbr: "Roto" },
  { name: "Winkhaus", abbr: "Winkhaus" },
  { name: "Maco", abbr: "Maco" },
  { name: "Sobinco", abbr: "Sobinco" },
  { name: "SKG", abbr: "SKG" },
  { name: "M&C", abbr: "M&C" },
];

export default function LogoWall() {
  const { t } = useTranslation("home");

  return (
    <section className="bg-white py-10 md:py-12 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <p className="text-center font-geist text-xs md:text-sm uppercase tracking-wider text-brand-text mb-6 md:mb-8">
          {t("logoWall.title")}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-14">
          {brands.map((b) => (
            <div
              key={b.name}
              className="font-geist font-bold text-lg md:text-2xl text-brand-text/40 hover:text-brand-blue transition-all duration-300 cursor-default select-none grayscale hover:grayscale-0"
            >
              {b.abbr}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}